<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'request-tracking.title'">_Seguimiento de solicitudes y descarga de auditorías</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <div class="common-table__container-border">
      <div class="common-table-header__container">
        <div class="common-table-body__inner-row w-[calc(100%-30px)]">
          <div class="common-table-cell__container w-[23%]">
            <filter-by-list-and-order
              [item]="requestTracking.requestFilter"
              [list]="requestTracking.requestList"
              (launchActionFilterOrderEmit)="filterOrder($event, 'request')">
            </filter-by-list-and-order>
          </div>
          <div class="common-table-cell__container w-[17%]">
            <filter-by-order
              [item]="requestTracking.creationDateFilter"
              [filterOrder]="requestTracking.filterOrder"
              [order]="requestTracking.orderOperationDate"
              (launchActionFilterOrderEmit)="filterOrder($event)">
            </filter-by-order>
          </div>
          <div class="common-table-cell__container w-[21%]">
            <filter-by-search-and-order
              [item]="requestTracking.recipientsFilter"
              (launchActionFilterOrderEmit)="filterOrder($event, 'addressee')">
            </filter-by-search-and-order>
          </div>
          <div class="common-table-cell__container w-[19%]">
            <filter-by-list-and-order
              [item]="requestTracking.stateFilter"
              [list]="requestTracking.stateList"
              (launchActionFilterOrderEmit)="filterOrder($event, 'state')">
            </filter-by-list-and-order>
          </div>
          <div class="common-table-cell__container w-[20%]">
            <span-tooltip class="common-table-cell__title-text-label"
              [text]="'request-tracking.audit' | afTranslate"></span-tooltip>
          </div>
        </div>
      </div>
      <div class="common-table-body__container h-[230px]">
        @for (requestOption of requestTracking.filterListTracking | afOrderBy:'creationDate': requestTracking.orderOperationDate; track $index) {
          <div class="common-table-body__row-tracking">
            @for (userColumn of requestOption.users; track $index) {
              <div class="common-table-body__row-inner-tracking"
                [ngClass]="{'common-table-body__row-inner-tracking--last': $last}">
                <div class="common-table-body__inner-row w-[calc(100%-30px)]">
                  @if ($first) {
                    <div class="common-table-cell__container w-[23%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="requestOption.request"></span-tooltip>
                    </div>
                    <div class="common-table-cell__container w-[17%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="requestOption.creationDate | convertDate:'without-time'"></span-tooltip>
                    </div>
                  }@else {
                    <div class="common-table-cell__container w-[40%]"></div>
                  }
                  <div class="common-table-cell__container w-[21%]">
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="userColumn.addressee"></span-tooltip>
                  </div>
                  <div class="common-table-cell__container w-[19%]">
                    @if(!requestOption.onlyFirst || $first){
                      <div [class]="'common-tag__state-task common-tag__state-task--' + (userColumn.stateId | colors)">
                        <span-tooltip class="common-tag__state-task-text"
                          [text]="userColumn.state"></span-tooltip>
                      </div>
                    }
                  </div>
                  <div class="common-table-cell__container w-[20%]">
                    @if(!requestOption.onlyFirst || $first){
                      @if (userColumn.audit){
                        <button class="common-button__link-table"
                          (click)="downloadAudit(requestOption, userColumn)">
                          <span class="common-button__link-text-table"
                            [afTranslate]="'request-tracking.download-audit'">_Descargar auditoría</span>
                        </button>
                      }@else {
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="'request-tracking.not-available' | afTranslate"></span-tooltip>
                      }
                    }
                  </div>
                </div>
                @if($first){
                  <div class="common-table-cell__container-actions w-[30px]">
                    <button class="common-button__icon-md-noborder"
                      (click)="showTracking(requestOption)"
                      pTooltip="{{'request-tracking.show-details' | afTranslate}}"
                      tooltipPosition="bottom">
                      <i class="lf-icon-open-window common-icon__md"></i>
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
      <div class="pagination-control">
        <div class="pagination-control__container-text-pagination">
          <span class="pagination-control__text-pagination-bold">
            <span [afTranslate]="'common.total'">_Total</span>:
            <span>{{requestTracking.filterListTracking?.length}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.close'">_Cerrar</span>
    </button>
  </div>
</div>
